<template>
  <ion-page>
    <ion-header :translucent="true">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-button color="primary"></ion-menu-button>
        </ion-buttons>
        <ion-title>New GPS Device</ion-title>
      </ion-toolbar>
    </ion-header>
    
    <ion-content :fullscreen="true">
      <ion-header collapse="condense">
        <ion-toolbar>
          <ion-title size="large">New GPS Device</ion-title>
        </ion-toolbar>
      </ion-header>
    
      <div id="container">
          <div v-if="gps!=null && !isScanning">
                <ion-item>
                    <ion-label position="floating">Supplier</ion-label>
                    <ion-input readonly v-model="gps.supplier"></ion-input>
                </ion-item>
                <ion-item>
                    <ion-label position="floating">Serial</ion-label>
                    <ion-input readonly v-model="gps.serial"></ion-input>
                </ion-item>
                <ion-item>
                    <ion-label position="floating">Version</ion-label>
                    <ion-input readonly v-model="gps.version"></ion-input>
                </ion-item>
                <ion-item>
                    <ion-label position="floating">Slot 1 Phone</ion-label>
                    <ion-input readonly v-model="gps.slot1.phoneNumber"></ion-input>
                </ion-item>
                <ion-item>
                    <ion-label position="floating">Slot 1 Operator</ion-label>
                    <ion-input readonly v-model="gps.slot1.operator"></ion-input>
                </ion-item>
                <ion-item>
                    <ion-label position="floating">Slot 1 IMEI</ion-label>
                    <ion-input readonly v-model="gps.slot1.imeiNumber"></ion-input>
                </ion-item>
                <template v-if="gps.slot2!=null">
                    <ion-item>
                        <ion-label position="floating">Slot 2 Phone</ion-label>
                        <ion-input readonly v-model="gps.slot2.phoneNumber"></ion-input>
                    </ion-item>
                    <ion-item>
                        <ion-label position="floating">Slot 2 Operator</ion-label>
                        <ion-input readonly v-model="gps.slot2.operator"></ion-input>
                    </ion-item>
                    <ion-item>
                        <ion-label position="floating">Slot 2 IMEI</ion-label>
                        <ion-input readonly v-model="gps.slot2.imeiNumber"></ion-input>
                    </ion-item>
                </template>
                <ion-button expand="block" @click="save" color="success">Import GPS Device</ion-button>
          </div>
          <ion-button v-if="!isScanning"  @click="scan">Scan QR Code</ion-button>
        
      </div>
      <ion-fab v-if="isScanning" vertical="bottom" horizontal="start" slot="fixed">
            <ion-fab-button @click="cancel" color="danger">
                <ion-icon :md="close"></ion-icon>
            </ion-fab-button>
        </ion-fab>
    </ion-content>
  </ion-page>
</template>

<script>
import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonButton, IonFab, IonFabButton, IonIcon, IonItem, IonLabel, IonInput, alertController} from '@ionic/vue';
import { close } from 'ionicons/icons';
import { BarcodeScanner, SupportedFormat } from '@capacitor-community/barcode-scanner';

export default {
  name: 'New GPS Device',
  setup(){
      return {
          close
          }
  },
//   mounted(){
//       this.gps=JSON.parse(`
//         {
//             "slot1": {
//                 "phoneNumber": "017003310120",
//                 "operator": "GP",
//                 "imeiNumber": "11111112231111111"
//             },
//             "supplier": "DMA",
//             "version": "1.0",
//             "serial": "2999991219123"
//         }
//       `);
//   },
  components: {
    IonButtons,
    IonContent,
    IonHeader,
    IonMenuButton,
    IonPage,
    IonTitle,
    IonToolbar,
    IonButton,
    IonFab,
     IonFabButton,
     IonIcon,
     IonItem,
    IonLabel,
    IonInput
  },
  data(){
      return {
         gps:null,
         isScanning:false,
      }
  },
  methods:{
    async scan(){
        const status = await BarcodeScanner.checkPermission({ force: true });
        if(status.granted){
            BarcodeScanner.prepare();
            this.isScanning=true;
            document.getElementsByTagName("ion-content")[1].style.setProperty("--background",'transparent');
            const result = await BarcodeScanner.startScan({ targetedFormats: [SupportedFormat.QR_CODE] });
            if (result.hasContent) {
                this.isScanning=false;
                document.getElementsByTagName("ion-content")[1].style.setProperty("--background",'#fff');
                this.gps=JSON.parse(result.content); // log the raw scanned content
            }
        }else{
            this.presentResponseAlert('Warning','You must allow camera permission');
        }
        
      },
      cancel(){
          this.isScanning=false;
          BarcodeScanner.stopScan();
          document.getElementsByTagName("ion-content")[1].style.setProperty("--background",'#fff');
      },
      async save(){
         
        const data={
            'serial':this.gps.serial,
            'version':this.gps.version,
            'gps_company':this.gps.supplier,
            'slot1_mobile_number':this.gps.slot1.phoneNumber,
            'slot1_imei_number':this.gps.slot1.imeiNumber,
            'slot1_mobile_operator':this.gps.slot1.operator,
        };
        if(this.gps.slot2!=null){
            data['slot2_mobile_number']=this.gps.slot2.phoneNumber;
            data['slot2_imei_number']=this.gps.slot2.imeiNumber;
            data['slot2_mobile_operator']=this.gps.slot2.operator;
        }
        data['username'] = window.localStorage.username,
        data['password'] = window.localStorage.password,
      this.$http.post('importGpsDevice',data).then(response=>{
        if(response.status==200){
            this.gps=null;
          this.presentResponseAlert('Success','Device Imported successfully');
        }
      });      
    },
      async presentResponseAlert(type,message) {
      const alert = await alertController
        .create({
          header: type+'!',
          // subHeader: 'Subtitle',
          message: message,
          buttons: ['OK'],
        });
      await alert.present();

    },
  }
}
</script>

<style scoped>
#container {
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

#container strong {
  font-size: 20px;
  line-height: 26px;
}

#container p {
  font-size: 16px;
  line-height: 22px;
  color: #8c8c8c;
  margin: 0;
}

#container a {
  text-decoration: none;
}
</style>